var _rect, _rect2, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    x: -33.9,
    y: -9.8,
    opacity: 0.2,
    rx: 2.1,
    ry: 2.1,
    transform: "scale(-1 1) rotate(-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    x: -33.1,
    y: -10.5,
    fill: "#66b744",
    rx: 2.1,
    ry: 2.1,
    transform: "scale(-1 1) rotate(-45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 6c-1.7 0-3.2.2-4.5.6l-4 4c-.2 1-.3 2-.2 2.6.4 3.5 4 5.8 8.7 5.8 3.3 0 5 1.7 5 2.2.1.3.1 1.5-.5 1.9-.6.4-2.3.9-4.5.9-2.7 0-6-1.7-6-1.7a2 2 0 00-2.8.8l4.1 4a15 15 0 009.2.3l4-4c.2-1 .3-2 .2-2.6-.4-3.5-4-5.8-8.7-5.8-3.3 0-4.9-1.7-5-2.2 0-.3 0-1.5.6-1.9.6-.4 2.2-.9 4.4-.9 2.7 0 6 1.7 6 1.7a2 2 0 002.8-.8l-4.1-4A15 15 0 0016 6z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16 5c-1.7 0-3.2.2-4.5.6l-4 4c-.2 1-.3 2-.2 2.6.4 3.5 4 5.8 8.7 5.8 3.3 0 5 1.7 5 2.2.1.3.1 1.5-.5 1.9-.6.4-2.3.9-4.5.9-2.7 0-6-1.7-6-1.7a2 2 0 00-2.8.8l4.1 4a15 15 0 009.2.3l4-4c.2-1 .3-2 .2-2.6-.4-3.5-4-5.8-8.7-5.8-3.3 0-4.9-1.7-5-2.2 0-.3 0-1.5.6-1.9.6-.4 2.2-.9 4.4-.9 2.7 0 6 1.7 6 1.7a2 2 0 002.8-.8l-4.1-4A15 15 0 0016 5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 2a2 2 0 00-1.5.6l-11.9 12a2 2 0 00-.5 1.9c0-.4.2-.7.5-1l12-11.9c.7-.8 2-.8 2.9 0l11.9 12c.3.2.4.5.5.9a2 2 0 00-.5-2l-12-11.9A2 2 0 0016 2z",
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoap);
export default __webpack_public_path__ + "static/media/Soap.20e439c6.svg";
export { ForwardRef as ReactComponent };